<div [class]="!chart()?.export?classes():''" class="flex flex-col w-full items-stretch"
  [ngClass]="{'exportView':chart()?.export, }" [attr.data-chart]="chart()?.id">
  <ng-content></ng-content>
  <div [ngClass]="{'border border-zen border-opacity-10 rounded-sm':chart()?.export && !chart()?.custom}" class="block">
    @if (chart()?.availableToDisplay) {

    <zen-chart class="w-full" [data]="chart()" [width]="width()" [height]="height()" (click)="logData(chart())"
      [exportPageRows]="exportPageRows()" (exportPageLength)="exportPageLength.emit($event)" [language]="language()">
      <empty-section empty [isChart]="true"></empty-section>
    </zen-chart>

    }
    @else {
    <empty-section [isChart]="true"></empty-section>
    }
  </div>
</div>